var render = function render(_c,_vm){return _c('div',{staticClass:"left-border-decorator",class:_vm.props.value ? `background-color--${_vm.props.value}` : ''})
}
var staticRenderFns = []

export { render, staticRenderFns }